import { app } from '../app';

app.config(config);

/** @ngInject */
function config($locationProvider) {
    $locationProvider.hashPrefix('');
}



// WEBPACK FOOTER //
// ./src/portal/config/location.config.js